import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@shared/auth/AuthContext';
import { NamedIcon } from '@shared/ui/icons';

/** Business account in preview mode (no brand added yet): one persistent, quiet nudge. */
export default function PreviewBanner() {
  const { t } = useTranslation('customer');
  const { role, accessStatus } = useAuth();
  const { pathname } = useLocation();
  if (role === 'admin' || accessStatus === 'active' || pathname.endsWith('/connect')) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', margin: '0 auto 16px', maxWidth: 1200,
      padding: '10px 14px', borderRadius: 10, background: 'rgba(74,158,255,0.08)', border: '1px solid rgba(74,158,255,0.3)', fontSize: 13.5 }}>
      <span style={{ display: 'inline-flex' }}><NamedIcon name="sparkle" size={16} /></span>
      <span style={{ flex: 1, minWidth: 220, color: 'var(--text, #dde)' }}>
        {t('preview.banner', { defaultValue: 'Вы смотрите рынок по открытым данным. Добавьте Instagram своего бренда — откроются «Моя аналитика» и задания для блогеров.' })}
      </span>
      <NavLink to="/customer/connect" style={{ color: 'var(--accent, #4a9eff)', fontWeight: 600, whiteSpace: 'nowrap', textDecoration: 'none' }}>
        {t('preview.cta', { defaultValue: 'Добавить бренд →' })}
      </NavLink>
    </div>
  );
}
